import { toast } from "react-toastify";
import { AXIOS_CLIENT, AXIOS_CLIENT_IMAGE } from "../utils/Axios";
import { ACTIVE_RESERVATION, ADD_WATCHLIST, CART_LIST, CHECK_PAYMENT_STATUS, CHECKOUT_GUEST_DATA, CHECKOUT_PAGE, CITY_LIST, COUNTRY_LIST, CREATE_BOOKING, E_TICKET, EMPTY_CART_LIST, EVENT_GUEST_DATA_REQUIREMENTS, FINAL_BOOKING, GET_BOOKING_BY_ID, GET_BOOKINGS, HANDLE_RAZOR_PAY, PAY_DETAILS_API, REMOVE_FROM_WATCHLIST, REMOVE_RESERVATION, RESERVATION_TICKET, RESERVE_AGAIN, UPDATE_BOOKING, USER_PROFILE, WATCHLIST_ITEM } from "../constants";


export const getDataFromApi = async (api, filterSearchInput) => {
  try {
    let response = await AXIOS_CLIENT.get(
      filterSearchInput ? api + filterSearchInput : api
    );
    if (response.status === 200) {
      return response;
    }
  } catch (error) {
    // toast.error(error.message);
  }
};


export const getDataFromAPI_SVG = async (api, filterSearchInput) => {
  try {
    let response = await AXIOS_CLIENT_IMAGE.get(
      filterSearchInput ? api + filterSearchInput : api
    );
    if (response.status === 200) {
      return response;
    }
  } catch (error) {
    toast.error(error.message);
  }
};

export const makeRequest = async (endpoint, data, method = "post") => {
  try {
    const response = await AXIOS_CLIENT[method](endpoint, data)
    if (response) {
      return response?.data
    }
  } catch (error) {
    console.log(endpoint.toUpperCase() + ": ", error.message);
  }
}


export const RESERVATION_API = async (data) => {
  return await makeRequest(RESERVATION_TICKET, data)
}

export const CART_LIST_API = async (data) => {
  return await makeRequest(CART_LIST, null, "get")
}

export const EMPTY_CART_LIST_API = async (data) => {
  return await makeRequest(EMPTY_CART_LIST, null, "get")
}

export const PAY_DETAILS_API_INTEGRATION = async (id) => {
  return await makeRequest(`${PAY_DETAILS_API}/${id}/pay-details`, null, "get")
}

export const ADD_WATCHLIST_API = async (data) => {
  return await makeRequest(ADD_WATCHLIST, data)
}

export const WATCHLIST_ITEM_API = async (data) => {
  return await makeRequest(WATCHLIST_ITEM, data, "get")
}

export const REMOVE_FROM_WATCHLIST_API = async (data) => {
  return await makeRequest(`${REMOVE_FROM_WATCHLIST}/${data}`, null, "get")
}

export const GUEST_DATA_REQUIREMENT = async (data) => {
  return await makeRequest(`${REMOVE_FROM_WATCHLIST}/${data}`, null, "get")
}

export const REMOVE_RESERVATION_API = async (data) => {
  return await makeRequest(`${REMOVE_RESERVATION}`, data)
}

export const CHECKOUT_GUEST_DETAIL_API = async (data) => {
  return await makeRequest(`${CHECKOUT_GUEST_DATA}/${data}/guestdata`, null, "get")
}

export const SUBMIT_RESERVATION_GUEST_DATA = async (id, data) => {
  return await makeRequest(`${CHECKOUT_GUEST_DATA}/${id}/guestdata`, data, "post")
}

export const COUNTRY_LIST_API = async (data) => {
  return await makeRequest(`${COUNTRY_LIST}`, null, "get")
}

export const CITY_LIST_API = async (data) => {
  return await makeRequest(`${CITY_LIST}`, data, "post")
}

export const USER_PROFILE_API = async (data) => {
  return await makeRequest(`${USER_PROFILE}`, null, "get")
}

export const EVENT_GUEST_DATA_REQUIREMENTS_API = async (id, data) => {
  return await makeRequest(`${EVENT_GUEST_DATA_REQUIREMENTS}/${id}/guestdata`, null, "get")
}

export const CHECKOUT_API = async (id, data) => {
  return await makeRequest(`${CHECKOUT_PAGE}/${id}`, null, "get")
}

export const HANDLE_RAZOR_PAY_API = async (data) => {
  return await makeRequest(`${HANDLE_RAZOR_PAY}`, data, "post")
}

export const CREATE_BOOKING_API = async (id, data) => {
  return await makeRequest(`${CREATE_BOOKING}/${id}`, data, "post")
}

export const GET_BOOKING_DETAILS_BY_ID_API = async (id) => {
  return await makeRequest(`${GET_BOOKING_BY_ID}/${id}`, null, "get")
}

export const RESERVE_AGAIN_API = async (data) => {
  return await makeRequest(`${RESERVE_AGAIN}`, data, "post")
}

export const GET_BOOKINGS_API = async (data) => {
  return await makeRequest(`${GET_BOOKINGS}`, data, "post")
}

export const FINAL_BOOKING_API = async (id) => {
  return await makeRequest(`${FINAL_BOOKING}/${id}`, null, "get")
}

export const CHECK_PAYMENT_STATUS_API = async (id) => {
  return await makeRequest(`${CHECK_PAYMENT_STATUS}/${id}`, null, "get")
}

export const GET_ACTIVE_RESERVATION_API = async (id) => {
  return await makeRequest(`${ACTIVE_RESERVATION}`, null, "get")
}

export const E_TICKET_API = async (data) => {
  return await makeRequest(`${E_TICKET}`, data, "post")
}

export const UPDATE_BOOKING_API = async (id) => {
  return await makeRequest(`${UPDATE_BOOKING}/${id}`, null, "get")
}
